<template>
	<div style="background: #f3f4f7" v-loading.fullscreen.lock="fullscreenLoading">
		<dialogBox :dialogFlag="subFlag" @callFn="tcFn" @qrsFn="tcFn" title="您将离开组卷放弃当前试卷">
			<div class="tcBox">
				<div class="tcItem tcItem1">
					<div>
						<img src="@/assets/img/tm.svg" alt="" />
					</div>
					<p>共有：{{ temTestquest.examinationQuestionIdList?.length }}题</p>
				</div>
				<div class="tcItem tcItem2">
					<div>
						<img src="@/assets/img/yz.svg" alt="" />
					</div>
					<p>填充：{{ yzTnum }}题</p>
				</div>
				<div class="tcItem tcItem3">
					<div>
						<img src="@/assets/img/编组.svg" alt="" />
					</div>
					<p>空白：{{ wzTnum }}题</p>
				</div>
			</div>
			<template v-slot:footer>
				<div slot="footer">
					<div class="dialog-footer">
						<div class="loadBtn" @click="lkFn">确认离开</div>
						<div class="loadBtn loadBtnQr" @click="tcFn">继续组卷</div>
					</div>
				</div>
			</template>
		</dialogBox>
		<userHeader />
		<fuHeader :txt="a" type="2" height="53px" />
		<div class="bodyWrapper">
			<div class="gudBtns">
				<div class="gudBtnItem gudBack supHove3" @click="$router.back()">
					<img src="@/assets/img/back.svg" alt="" />
					<span>返回</span>
				</div>
			</div>
			<div class="timBox">
				<div class="timSx">
					<shaixTel :htNum="htNum" :kdNum="kdNum" ref="sxTel" @dataFn="perList" :disBtn="decFlag" />
				</div>
				<div class="timTabs">
					<div class="timTab" v-if="decFlag">试题篮子-内容预览</div>
					<div class="timTab" v-if="!decFlag">
						<div class="timTabItem timTabItemh">排序</div>
						<div class="timTabItem supHove3" @click="pxFn(1)" :class="ruleform.sort == 1 ? 'active' : ''">综合</div>
						<div
							class="timTabItem supHove3"
							:class="ruleform.sort == 2 && ruleform.sortType == 0 ? 'timTabItem1' : ruleform.sort == 2 && ruleform.sortType == 1 ? 'timTabItem2' : ''"
							@click="pxFn(2)"
						>
							<span>难易度</span>
							<i class="el-icon-caret-top"></i>
							<i class="el-icon-caret-bottom"></i>
						</div>
						<div
							class="timTabItem supHove3"
							:class="ruleform.sort == 3 && ruleform.sortType == 0 ? 'timTabItem1' : ruleform.sort == 3 && ruleform.sortType == 1 ? 'timTabItem2' : ''"
							@click="pxFn(3)"
						>
							<span>词数</span>
							<i class="el-icon-caret-top"></i>
							<i class="el-icon-caret-bottom"></i>
						</div>
						<div
							class="timTabItem supHove3"
							:class="ruleform.sort == 4 && ruleform.sortType == 0 ? 'timTabItem1' : ruleform.sort == 4 && ruleform.sortType == 1 ? 'timTabItem2' : ''"
							@click="pxFn(4)"
						>
							<span>轮次</span>
							<i class="el-icon-caret-top"></i>
							<i class="el-icon-caret-bottom"></i>
						</div>
					</div>
					<div v-if="type != 2" class="timTabBtn supHove3" :class="decFlag ? '' : 'clred'" @click="tkFn">
						<img src="@/assets/img/编组 (2).png" v-show="!decFlag" alt="" />
						<img src="@/assets/img/编组 (3).png" v-show="decFlag" alt="" />
						{{ type == 2 ? '试题篮' : decFlag ? '返回题库' : '选择模板' }}
					</div>
					<div v-if="type == 2" class="timTabBtns">
						<div class="timTabBtn supHove3" :class="{ active: stFlag == 1 }" @click="stTabFn(1)">
							<svg class="timTabBtnIcon" viewBox="0 0 18 18" fill="none" aria-hidden="true">
								<path d="M5 2h6l3 3v10a1 1 0 01-1 1H5a1 1 0 01-1-1V3a1 1 0 011-1z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round" />
								<path d="M11 2v3h3M6 8h6M6 10.5h6M6 13h4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
							</svg>
							试题库
						</div>
						<div class="timTabBtn supHove3" :class="{ active: stFlag == 2 }" @click="stTabFn(2)">
							<svg class="timTabBtnIcon" viewBox="0 0 18 18" fill="none" aria-hidden="true">
								<path d="M6.5 6.5V5.8a2.5 2.5 0 015 0V6.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
								<path d="M4 6.5h10l-.8 8.5H4.8L4 6.5z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round" />
								<path d="M7 10v3.5M11 10v3.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
							</svg>
							试题篮
						</div>
						<div class="timTabBtn supHove3" :class="{ active: stFlag == 3 }" @click="stTabFn(3)">
							<svg class="timTabBtnIcon" viewBox="0 0 18 18" fill="none" aria-hidden="true">
								<path d="M4 2.5h7a1 1 0 011 1v11H5a1 1 0 01-1-1v-11a1 1 0 011-1z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round" />
								<path d="M12 3.5h2.5a1 1 0 011 1v9.5H12" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round" />
								<path d="M7.2 7.5l3.6 3.6M10.8 7.5l-3.6 3.6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
							</svg>
							错题本
						</div>
					</div>
				</div>
				<div class="ctbTabs" v-if="type == 2 && stFlag == 3 && !decFlag">
					<div class="ctbTab">
						<div class="ctbTabItem" @click="ctbTabFn(1)" :class="{ ctbTabItemActive: ctbTabFlag == 1 }">课本类</div>
						<div class="ctbTabItem" @click="ctbTabFn(3)" :class="{ ctbTabItemActive: ctbTabFlag == 3 }">真题类</div>
						<div class="ctbTabItem" @click="ctbTabFn(5)" :class="{ ctbTabItemActive: ctbTabFlag == 5 }">试卷类</div>
						<div class="ctbTabItem" @click="ctbTabFn(2)" :class="{ ctbTabItemActive: ctbTabFlag == 2 }">每日一听类</div>
						<div class="ctbTabItem" @click="ctbTabFn(6)" :class="{ ctbTabItemActive: ctbTabFlag == 6 }">机考类</div>
					</div>
				</div>
				<div class="timCont">
					<div class="kaoshiCont" v-if="!decFlag">
						<shitiLz v-if="perData.length" :stStand="stStand" @lzFn="stFn" :type="stStand?.type ? '3' : '2'" :perData="perData" />
						<fenye v-if="perData.length" :total="total" ref="fybox" @dataFn="perList" />
						<div style="padding: 100px 0" v-if="!perData.length">
							<el-empty :description="stFlag == 3 ? '暂无错题' : stStand ? '当前没有符合要求的试题' : '暂无试题'"></el-empty>
						</div>
					</div>
					<div class="kaoshiCont" v-if="decFlag">
						<shitiLz :perData="lzData" @lzFn="stFn1" type="" />
					</div>
					<div class="timContR" v-if="type != 2">
						<div class="meiWecTit meiWecTit5">
							<span>试题篮子</span>
							<div class="qbIcon supHove3" @click="gdBtn">
								更多
								<i class="el-icon-arrow-right"></i>
							</div>
						</div>
						<div class="meiWecRBoxC">
							<div class="meiWecRCItem supHove4" @click="lzFns(item)" v-for="(item, index) in stData" :key="index">
								<el-image class="imgs" :src="$imgFn('试卷', 2)" lazy></el-image>
								<div class="meiWecRCItemR">
									<p :title="item.number">{{ item.number }}</p>
									<div class="meiWecRCItemRF" :title="item.testCenterName">考点：{{ item.testCenterName }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<foot />
	</div>
</template>

<script>
import foot from '@/components/foot/foot';
import userHeader from '@/components/hearder/userHeader';
import fuHeader from '@/components/hearder/fuHeader';
import shitiLz from '@/components/my/shitiLz';
import shaixTel from '@/components/tiku/shaixTel';
import dialogBox from '@/components/pubComponents/dialogBox';
import fenye from '@/components/pubComponents/fenye';
import { mapState } from 'vuex';

export default {
	name: 'zuJuan',
	data() {
		return {
			type: 1,
			txt: '',
			subFlag: false,
			decFlag: false, // 试题篮子是否显示
			ruleform: {
				sort: 1, //  1 综合排序 2 难易度 3 次数 4 轮次
				sortComprehensive: '',
				sortType: '' // 0升 1降
			},
			isZjFlag: false,
			notInQuestionId: '',
			yzTnum: 0,
			wzTnum: 0,
			perData: [],
			stStand: {},
			stFlag: 1, // 1题库 2篮子 3错题本
			ctbTabFlag: 1, // 错题本类别：1课本 3真题 5试卷 2每日一听 6机考
			lzData: [],
			fullFlag: true,
			fullscreenLoading: false,
			bsIns: 2,
			bsData: ['0.5', '0.75', '1', '1.25', '1.5', '1.75'],
			a: ['个人中心'],
			stData: [],
			kdNum: 0,
			htNum: 0,
			nextName: '',
			nextQuery: '',
			nextParams: ''
		};
	},
	components: {
		userHeader,
		fuHeader,
		shitiLz,
		shaixTel,
		dialogBox,
		fenye,
		foot
	},
	computed: {
		...mapState(['temTestquest'])
	},
	beforeRouteLeave(to, from, next) {
		if (this.stStand?.type) {
			if ((to.path == '/xuanzMb' && this.stStand) || to.query.tys == '777') {
				next();
			} else {
				this.nextQuery = to.query;
				this.nextParams = to.params;
				this.nextName = to.path;
				this.subFlag = true;
			}
		} else {
			next();
		}
	},
	methods: {
		gdBtn() {
			this.$router.push({
				path: 'myInfo',
				query: {
					routeName: 'stlz'
				}
			});
		},
		subjBnt() {
			this.subFlag = true;
		},
		lkFn() {
			this.subFlag = false;
			this.$router.push({
				path: this.nextName,
				query: {
					...this.nextQuery,
					tys: 777
				},
				params: {
					...this.nextParams
				}
			});
			console.log(this.nextName, '离开了');
		},
		tcFn() {
			this.subFlag = false;
		},
		stTabFn(flag) {
			if (this.stFlag === flag) return;
			this.stFlag = flag;
			this.perList({
				notInQuestionId: this.notInQuestionId,
				pageNum: 1,
				pageSize: 10
			});
		},
		ctbTabFn(val) {
			if (this.ctbTabFlag === val) return;
			this.ctbTabFlag = val;
			this.perList({
				notInQuestionId: this.notInQuestionId,
				pageNum: 1,
				pageSize: 10
			});
		},
		lzFns(item) {
			this.lzData = [item];
			this.decFlag = true;
		},
		tkFn() {
			if (this.decFlag == false) {
				this.$router.push({
					path: 'xuanzMb',
					query: {
						txt: '选择模板'
					}
				});
			} else {
				this.decFlag = false;
			}
		},
		yusFn(type) {
			if (type == '-') {
				if (this.bsIns == 0) return;
				this.bsIns--;
			} else {
				if (this.bsIns == 5) return;
				this.bsIns++;
			}
		},
		pxFn(val) {
			if (val != 1) {
				this.ruleform.sortComprehensive = '';
				if (this.ruleform.sort == val) {
					this.ruleform.sortType = this.ruleform.sortType === '' ? 0 : this.ruleform.sortType === 0 ? 1 : 0;
				} else {
					this.ruleform.sortType = 0;
				}
			} else {
				this.ruleform.sortType = '';
				let randomNum = Math.floor(Math.random() * 1000000);
				this.ruleform.sortComprehensive = randomNum.toString().padStart(6, '0');
			}
			console.log(this.ruleform.sortType, 7777);
			this.ruleform.sort = val;
			this.perList({
				notInQuestionId: this.notInQuestionId,
				pageNum: 1,
				pageSize: 10
			});
		},
		btnFn(txt) {
			let str = this.a[1] + '~' + txt;
			this.$router.push({
				path: './scDec',
				query: {
					type: 1,
					txt: str
				}
			});
		},
		kaoBtn(txt) {
			let str = this.a[1] + '~' + txt;
			this.$router.push({
				path: './kaoshi',
				query: {
					txt: str
				}
			});
		},
		perList(data) {
			let pre = '';
			console.log(data, 77777);
			if (data) {
				pre = {
					...data,
					pageSize: this.$refs['fybox']?.pageSize || 10
				};
			} else {
				pre = {
					pageNum: this.$refs['fybox']?.pageNum,
					pageSize: this.$refs['fybox']?.pageSize
				};
			}
			if (pre.pageNum == 1 && this.ruleform.sort == 1) {
				let randomNum = Math.floor(Math.random() * 1000000);
				this.ruleform.sortComprehensive = randomNum.toString().padStart(6, '0');
			}
			let { difficultyScore, interrogativeId, cisVal, roundsId, ...resData } = this.$refs.sxTel.sxData;
			let datas = {
				difficultyScore: difficultyScore.join(','),
				interrogativeId: interrogativeId.join(','),
				minWordsNumber: cisVal
					.map((item) => {
						return item?.split('~')[0];
					})
					.join(','),
				maxWordsNumber: cisVal
					.map((item) => {
						return item?.split('~')[1];
					})
					.join(','),
				roundsId: roundsId.join(','),
				...resData,
				...this.ruleform
			};
			console.log(JSON.stringify(datas), 7777);
			this.fullscreenLoading = true;
			let surl = '';
			if (this.stFlag == 1) {
				surl = 'api/app/yydExaminationQuestion/list';
			} else if (this.stFlag == 2) {
				surl = 'api/app/yydExaminationQuestion/selectYydExaminationQuestionListBasket';
			} else {
				surl = 'api/app/yydErrorEdition/selectYydErrorEditionQuestionList';
			}
			this.$http
				.get(surl, {
					params: {
						...datas,
						...pre,
						...(this.stFlag == 3 ? { type: this.ctbTabFlag } : {})
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						console.log(res.rows, 88888);
						this.perData = res.rows || [];
						this.total = res.total;
						if (resData.topic) {
							this.htNum = res.total;
						} else {
							this.htNum = 0;
						}
						if (resData.testCenter) {
							this.kdNum = res.total;
						} else {
							this.kdNum = 0;
						}
					}
				});
		},
		stFn(it) {
			console.log('stFn');
			if (it) {
				this.perData = this.perData.filter((item) => item.examinationQuestionId !== it.examinationQuestionId);
			}
			// 试题篮子
			this.$http.get('api/app/yydExaminationQuestion/selectYydExaminationQuestionListBasket').then((res) => {
				console.log(res);
				if (res.code == 200) {
					this.stData = res.rows || [];
				}
			});
		},
		stFn1(it) {
			console.log('stFn');
			if (it) {
				this.lzData = this.lzData.filter((item) => item.examinationQuestionId !== it.examinationQuestionId);
			}
			// 试题篮子
			this.$http.get('api/app/yydExaminationQuestion/selectYydExaminationQuestionListBasket').then((res) => {
				console.log(res);
				if (res.code == 200) {
					this.stData = res.rows || [];
				}
			});
		},
		init() {
			this.stFn();
			this.perList({
				notInQuestionId: this.notInQuestionId,
				pageNum: 1,
				pageSize: 10
			});
		}
	},
	mounted() {
		const { type, txt, stStand } = this.$route.query;
		if (stStand) {
			this.stStand = JSON.parse(stStand);
			if (stStand && this.temTestquest.examinationQuestionIdList) {
				console.log(this.temTestquest, 999999);
				let is = '';
				this.temTestquest.examinationQuestionIdList.forEach((item) => {
					if (item.stdec.examinationQuestionId) {
						is += item.stdec.examinationQuestionId + ',';
					}
				});
				if (is) {
					this.notInQuestionId = is.substring(0, is.length - 1);
				}

				this.mxItem = {
					templateId: this.temTestquest.templateId,
					templateDetail: this.temTestquest.examinationQuestionIdList.slice(5, this.temTestquest.examinationQuestionIdList?.length)
				};
				let num = 0;
				this.temTestquest.examinationQuestionIdList.forEach((item) => {
					if (item.stdec.examinationQuestionId) {
						num++;
					}
				});
				this.yzTnum = num;
				this.wzTnum = this.temTestquest.examinationQuestionIdList?.length - num;
			}
		}
		this.type = type || 1;
		this.txt = txt || '';
		this.a.push(txt);
		this.init();
	}
};
</script>
<style lang="scss" scoped>
.timBox {
	width: 1200px;
	margin: 0 auto 10px;
	.timSx {
		padding: 20px 21px;
		background: #ffffff;
		margin: 10px 0;
	}
	.timTabs {
		height: 56px;
		background: #ffffff;
		border-radius: 4px;
		display: flex;
		justify-content: space-between;
		padding: 0 18px 0 23px;
		align-items: center;
		.timTabBtn {
			height: 36px;
			width: 100px;
			background: #1d7b3a;
			border-radius: 7px;
			border: 1px solid #14652d;
			font-size: 14px;
			color: #ffffff;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			img {
				width: 18px;
				height: 18px;
				margin-right: 4px;
			}
			.timTabBtnIcon {
				width: 18px;
				height: 18px;
				margin-right: 4px;
				flex-shrink: 0;
			}
		}
		.timTabBtns {
			display: flex;
			gap: 8px;
			.timTabBtn {
				width: 90px;
				background: #ffffff;
				color: #1d7b3a;
				&.active {
					background: #1d7b3a;
					color: #ffffff;
				}
			}
		}
		.clred {
			background: #d33931;
			border: 1px solid #d33931;
		}

		.timTab {
			flex: 1;
			display: flex;
			align-items: center;
			font-size: 14px;
			color: #000000;
		}
		.timTabItemh {
			color: #9a9a9a;
		}
		.timTabItem {
			display: flex;
			margin-right: 48px;
			cursor: pointer;
			position: relative;
			i {
				position: absolute;
				color: #d8d8d8;
				line-height: 20px;
				width: 14px;
				height: 14px;
				font-size: 12px;
			}
			.el-icon-caret-top {
				top: 50%;
				right: -16px;
				transform: translateY(-100%);
			}
			.el-icon-caret-bottom {
				top: 50%;
				right: -16px;
				transform: translateY(-50%);
			}
		}
		.timTabItem1 {
			span {
				color: #1d7b3a;
			}
			.el-icon-caret-top {
				color: #1d7b3a;
			}
		}
		.timTabItem2 {
			span {
				color: #1d7b3a;
			}
			.el-icon-caret-bottom {
				color: #1d7b3a;
			}
		}
		.active {
			color: #1d7b3a;
		}
	}
	.ctbTabs {
		margin-top: 10px;
		padding: 0 23px;
		background: #ffffff;
		border-radius: 4px;
		.ctbTab {
			display: flex;
			align-items: center;
			font-size: 14px;
			color: #8a8a8a;
			height: 50px;
			.ctbTabItem {
				margin-right: 48px;
				cursor: pointer;
				&:last-child {
					margin-right: 0;
				}
			}
			.ctbTabItemActive {
				color: #1d7b3a;
				font-weight: bold;
			}
		}
	}
	.timCont {
		display: flex;
		margin-top: 10px;
		.timContL {
			flex: 1;
			margin-right: 10px;
			.timContLB {
				background: #ffffff;
				border-radius: 6px;
				padding: 10px 17px 42px;
				h1 {
					height: 44px;
					line-height: 44px;
					color: #000000;
					font-size: 16px;
					font-weight: bold;
					padding-left: 2px;
				}
				.timContLBTm {
					margin-bottom: 20px;
					font-size: 12px;
					&:last-of-type {
						margin-bottom: 0;
					}
					.timContLBTmT {
						color: #9c9c9c;
						line-height: 2;
						margin-bottom: 12px;
					}
					.timContLBTmW {
						color: #000000;
						font-weight: bold;
						margin-bottom: 9px;
					}
					.timContLBTmD {
						line-height: 2;
						font-size: 12px;
						color: #000;
					}
				}
			}
			.timContLT {
				background: #ffffff;
				border-radius: 6px;
				margin-bottom: 10px;
				padding: 16px 19px 20px 17px;
				> p {
					display: flex;
					align-items: center;
					color: #000000;
					font-size: 12px;
					font-weight: bold;
					margin-bottom: 16px;
					span {
						margin-left: 12px;
						color: #8f9190;
						font-weight: 400;
					}
				}
			}
			.timContLTTj {
				font-size: 12px;
				color: #000;
				margin-bottom: 16px;
				h2 {
					font-weight: bold;
					margin-bottom: 6px;
				}
				p {
					font-weight: 400;
				}
			}
		}
	}
	.timBoxTit {
		display: flex;
		.timBoxTitInfo {
			flex: 1;
			margin-right: 10px;
			height: 136px;
			background: #ffffff;
			border-radius: 6px;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			padding: 17px 17px 19px;
			position: relative;
			.timBoxTitInfoImg {
				width: 100px;
				height: 100px;
				margin-right: 11px;
				img {
					width: 100px;
					height: 100px;
					background: red;
					border-radius: 6px;
				}
			}
			.timBoxTitInfoCont {
				padding-right: 200px;
				flex: 1;
				.timBoxTitInfoFot {
					display: flex;
					align-items: center;
					font-size: 12px;
					color: #8f9190;
					.timBoxTitInfoFotItem {
						margin-right: 26px;
						display: flex;
						align-items: center;
						img {
							width: 12px;
							height: 12px;
							margin-right: 7px;
						}
					}
				}
				.timBoxTitInfoSts {
					margin-top: 10px;
					display: flex;
					align-items: center;
					font-size: 12px;
					color: #333333;
					margin-bottom: 7px;
					.timBoxTitInfoSt {
						margin-right: 21px;
						display: flex;
						align-items: center;
					}
					img {
						width: 13px;
						height: 13px;
						margin-right: 4px;
					}
				}
				.timBoxTitInfoP {
					display: flex;
					font-size: 12px;
					margin-bottom: 9px;
					&:last-of-type {
						margin-bottom: 0px;
					}
					p {
						width: 60px;
						margin-right: 18px;
					}
					span {
						margin-right: 22px;
						color: #333333;
						cursor: pointer;
					}
					.actives {
						color: #1d7b3a;
					}
					.tip {
						color: #8f9190;
					}
				}
				.timBoxTitInfoTit {
					display: flex;
					align-items: center;
					margin-bottom: 10px;
					.timBoxTitInfoZt {
						position: absolute;
						font-size: 12px;
						color: #1d7b3a;
						top: 20px;
						right: 19px;
					}
					h2 {
						color: #000000;
						font-size: 16px;
						font-weight: bold;
						margin-right: 16px;
					}
					.shouc {
						display: flex;
						justify-content: center;
						align-items: center;
						cursor: pointer;
						img {
							width: 15px;
							height: 15px;
							margin-right: 4px;
							margin-top: 2px;
						}
						span {
							font-size: 14px;
							color: #1d7b3a;
						}
					}
				}
			}
			.timBoxTitInfoRig {
				position: absolute;
				right: 21px;
				display: flex;
				bottom: 15px;
				.timBoxTitInfoBtn {
					width: 90px;
					height: 30px;
					background: #1d7b3a;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-left: 10px;
					font-size: 14px;
					color: #ffffff;
					border-radius: 6px;
					cursor: pointer;
					img {
						width: 17px;
						height: 17px;
						margin-right: 3px;
					}
				}
				.timBoxTitInfoBtn1 {
					background: #ffac3e;
				}
			}
		}
		.timBoxEw {
			width: 310px;
			height: 136px;
			background: #ffffff;
			border-radius: 6px;
			.timBoxEwTit {
				margin: 17px 0 25px;
				font-size: 18px;
				color: #000000;
				font-weight: bold;
				text-align: center;
			}
			.timBoxEwCont {
				display: flex;
				padding: 0 35px;
				justify-content: space-between;
				.timBoxEwItem {
					display: flex;
					flex-direction: column;
					align-items: center;
					h2 {
						margin-bottom: 10px;
						font-weight: bold;
						font-size: 22px;
						color: #000000;
					}
					p {
						font-size: 14px;
						color: #000000;
					}
				}
				.timBoxEwItem1 {
					h2,
					p {
						color: #23a14c;
					}
				}
				.timBoxEwItem2 {
					h2,
					p {
						color: #ee5923;
					}
				}
			}
		}
	}
}
.timContR {
	background: #fff;
	padding: 0 13px 15px;
	border-radius: 6px;
	width: 310px;
	box-sizing: border-box;
	.meiWecTit {
		height: 63px;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #f8f8f8;
		font-size: 18px;
		font-weight: bold;
		justify-content: space-between;
		> img {
			width: 30px;
			height: 30px;
			margin-right: 7px;
		}
		.qbIcon {
			font-size: 14px;
			color: #ababab;
			display: flex;
			align-items: center;
			font-weight: 400;
			line-height: 1;
			cursor: pointer;
			i {
				margin-left: 6px;
			}
		}
	}
	.meiWecRBoxC {
		margin-top: 5px;
		.meiWecRCItem {
			padding: 16px 3px;
			border-bottom: 1px solid #f8f8f8;
			display: flex;
			cursor: pointer;
			.imgs {
				width: 60px;
				height: 60px;
				margin-right: 7px;
				border-radius: 6px;
			}
			.meiWecRCItemR {
				flex: 1;
				display: flex;
				flex-direction: column;
				justify-content: center;
				p {
					overflow: hidden; /* 确保超出容器的内容被裁剪 */
					white-space: nowrap; /* 确保文本在一行内显示 */
					text-overflow: ellipsis; /* 超出部分显示省略号 */
					font-size: 14px;
					color: #000000;
					font-weight: bold;
					margin-bottom: 6px;
				}
				.meiWecRCItemRF {
					color: #8f9190;
					font-size: 12px;
					width: 170px;
					// 超出多行省略号
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
					text-overflow: ellipsis;
				}
			}
			&:last-of-type {
				border-bottom: none;
			}
		}
	}
}

.zzAdminItemJjI {
	padding: 0 12px;
	height: 22px;
	font-size: 12px;
	text-align: center;
	line-height: 22px;
	border-radius: 4px;
}
.zzAdminItemJjI0 {
	background: #fef7f0;
	color: #f7860f;
}
.zzAdminItemJjI1 {
	background: #fef7f0;
	color: #f7860f;
}
.zzAdminItemJjI3 {
	background: #f1f7fe;
	color: #1675e5;
}
.kaoshiCont {
	padding: 0 30px 29px;
	color: #000000;
	flex: 1;
	margin-right: 10px;
	background: #fff;
	border-radius: 6px;
	position: relative;
	.kaoshiFixYs {
		position: absolute;
		top: 22px;
		right: 7px;
		width: 108px;
		height: 98px;
		color: #fff;
		background: url('@/assets/img/ys.svg') 100% no-repeat;
		.kaoshiFixYsCont {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			margin-top: -4px;
		}
		.kaoshiFixP {
			position: absolute;
			bottom: 15px;
			width: 100%;
			display: flex;
			justify-content: center;
			font-size: 12px;
			align-items: center;
			p {
				margin: 0 6px;
			}
			img {
				width: 9px;
				height: 6px;
				cursor: pointer;
				margin-top: 1px;
			}
			.img1 {
				transform: rotate(90deg);
			}
			.img2 {
				transform: rotate(90deg);
			}
		}
	}

	.kaoshiTnum {
		height: 52px;
		line-height: 52px;
		font-size: 14px;
		color: #333333;
		border-bottom: 1px solid #f8f8f8;
		margin: 0 0 18px;
	}
	h1 {
		font-size: 28px;
		padding-top: 38px;
		margin-bottom: 25px;
		font-weight: bold;
		text-align: center;
	}
	h2 {
		font-size: 18px;
		margin-bottom: 27px;
		text-align: center;
		padding-bottom: 34px;
		border-bottom: 1px solid #f8f8f8;
	}
	.kaoshiTm {
		h3 {
			font-size: 18px;
			font-weight: bold;
			margin: 40px 0 13px;
			text-indent: 2em;
		}
		> p {
			font-size: 16px;
			line-height: 2;
			text-indent: 2em;
			margin-bottom: 38px;
		}
		.kaoshiXtim {
			h4 {
				font-weight: bold;
				font-size: 18px;
				margin: 40px 0;
			}
			.kaoshiT {
				margin-bottom: 40px;
				&:last-of-type {
					margin-bottom: 0;
				}
				.kaoshiXx {
					padding-left: 102px;

					p {
						margin-bottom: 36px;
						font-size: 18px;
						cursor: pointer;
						&:hover {
							color: #1d7b3a;
						}
					}
					.active {
						color: #1d7b3a;
					}
				}
				.kaoshiWt {
					display: flex;
					font-weight: bold;
					margin-bottom: 36px;
					.kaoshiWtBtn {
						margin-left: 19px;
						width: 63px;
						height: 26px;
						background: #1d7b3a;
						border-radius: 4px;
						color: #fff;
						font-size: 14px;
						display: flex;
						justify-content: center;
						align-items: center;
						font-weight: 400;
						cursor: pointer;
						img {
							width: 16px;
							height: 14px;
							margin-right: 6px;
						}
					}
					.kaoshiDa {
						width: 72px;
						margin-right: 30px;
						position: relative;
						display: flex;
						justify-content: space-between;
						span {
							position: absolute;
							top: 50%;
							left: 50%;
							transform: translate(-50%, -50%);
							margin-top: -2px;
						}
					}
				}
			}
		}
	}
}
.tcBox {
	margin: 6px 0 40px;
	display: flex;
	justify-content: space-between;
	.tcItem {
		width: 133px;
		height: 93px;
		background: #f8f9fd;
		border-radius: 4px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		font-size: 16px;
		img {
			width: 34px;
			height: 34px;
			margin-bottom: 7px;
		}
	}
	.tcItem1 {
		color: #000000;
	}
	.tcItem2 {
		color: #10c257;
	}
	.tcItem3 {
		color: #ffb126;
	}
}
.dialog-footer {
	display: flex;
	justify-content: center;
	padding-bottom: 10px;

	.loadBtn {
		width: 88px;
		height: 40px;
		text-align: center;
		line-height: 40px;
		background: #d33931;
		box-shadow: 0px 1px 2px 0px rgba(184, 200, 224, 0.22);
		font-size: 16px;
		color: #ffffff;
		border-radius: 6px;
		cursor: pointer;
	}
	.loadBtnQr {
		background: #1d7b3a;
		color: #ffffff;
		margin-left: 50px;
	}
}
</style>
